// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBankMethodsDto
 */
export interface IBankMethodsDto {
    /**
     * 
     * @type {number}
     * @memberof IBankMethodsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBankMethodsDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBankMethodsDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IBankMethodsDto interface.
 */
export function instanceOfIBankMethodsDto(value: object): value is IBankMethodsDto {
    return true;
}

export function IBankMethodsDtoFromJSON(json: any): IBankMethodsDto {
    return IBankMethodsDtoFromJSONTyped(json, false);
}

export function IBankMethodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBankMethodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IBankMethodsDtoToJSON(json: any): IBankMethodsDto {
    return IBankMethodsDtoToJSONTyped(json, false);
}

export function IBankMethodsDtoToJSONTyped(value?: IBankMethodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

